import actionTypes from './GTMWTWTA01ActionType';

/**
 * 作業時間承認
 */
const initialState = {
    isFetching: false,
    data: [],
    isError: false,
    err_type: "",
    err_detail: []
};

/**
 * 作業時間承認を承認するReducer
 * @param {*} state
 * @param {*} action
 */
export const workingtimeApproval = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.WORKINGTIME_APPROVAL_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                data: [],
                isError: false,
                err_type: "",
                err_detail: []
            });
        case actionTypes.WORKINGTIME_APPROVAL_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.data.data,
                isError: false,
                err_type: action.data.err_type,
                err_detail: action.data.err_detail
            });
        case actionTypes.WORKINGTIME_APPROVAL_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                data: {},
                isError: true,
                err_type: action.err,
                err_detail: []
            });
        case actionTypes.WORKINGTIME_APPROVAL_RESET:
            return Object.assign({}, state, {
                isFetching: false,
                isError: false,
                data: {},
                err_type: "",
                err_detail: []
            });
        default:
            return state;
    }
};
